<template>
  <div>
    <!-- tell the user that this is a work in progress -->
    <b-card
      class="mb-2"
    >
      <b-row class="border-bottom mb-2">
        <b-col
          cols="10"
        >
          <h4> Workspace Devices</h4>
          <p>
            This is a work in progress. Please check back later.
          </p>
        </b-col>
      </b-row>

    </b-card>

  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,

} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,

  },

}
</script>

<style>

</style>
